import { render, staticRenderFns } from "./QRQuestion.vue?vue&type=template&id=1c391678&"
import script from "./QRQuestion.vue?vue&type=script&lang=js&"
export * from "./QRQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports